import { useQuery } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export const leaveBalanceKeys = {
    all: ['leave-balances'],
    myBalance: (orgId) => [...leaveBalanceKeys.all, 'my-balance', orgId],
};

export function useMyLeaveBalance(orgId) {
    const { user } = useAuth();
    return useQuery({
        queryKey: leaveBalanceKeys.myBalance(orgId),
        queryFn: async () => {
            const response = await apiHelper.getResource('/leave/balances/my_balance/', { orgId });
            return response.data || response;
        },
        enabled: !!orgId && !!user?.employeeId,
    });
}
